// Configs 
export const GOOGLE_CLOUD_BASE_URL = "https://us-east1-free-shipping-progress-bar-wix.cloudfunctions.net";
export const BLOCKS_APP_ID = "83f6c32f-4091-4893-9062-d4f743e01b9e";

// Mapping object for template and item count to element selectors
export const templateMapping = {};

// Mapping suffix currencies
export const suffixCurrencies = [
    'ISK', // Icelandic króna
    'NOK', // Norwegian krone
    'SEK', // Swedish krona
    'DKK', // Danish krone
    'CZK', // Czech koruna
    'HUF', // Hungarian forint
    'PLN', // Polish złoty
    'RUB', // Russian ruble
    'TRY', // Turkish lira
    'ZAR', // South African rand
    'BRL', // Brazilian real
    'MXN', // Mexican peso
    'CLP', // Chilean peso
    'ARS', // Argentine peso
    'COP', // Colombian peso
    'PEN', // Peruvian sol
    'IDR', // Indonesian rupiah
    'VND', // Vietnamese đồng
    'ILS', // Israeli new shekel (often formatted with the symbol after the amount)
    'PKR', // Pakistani rupee
    'NGN', // Nigerian naira
    'UGX', // Ugandan shilling
    'TZS', // Tanzanian shilling
    'KES', // Kenyan shilling
    'KZT', // Kazakhstani tenge
    'UAH', // Ukrainian hryvnia
    'GHS', // Ghanaian cedi
    'MUR', // Mauritian rupee
    'MZN', // Mozambican metical
    'BAM', // Bosnia and Herzegovina convertible mark
    'RON', // Romanian leu
    'BGN', // Bulgarian lev
    'HRK', // Croatian kuna
    'MKD', // Macedonian denar
    'RSD', // Serbian dinar
    'JOD', // Jordanian dinar
    'MAD', // Moroccan dirham
    'TND', // Tunisian dinar
    'DZD', // Algerian dinar
    'EGP', // Egyptian pound
    'KWD', // Kuwaiti dinar
    'BHD', // Bahraini dinar
    'OMR', // Omani rial
    'QAR', // Qatari riyal
    'AED', // UAE dirham
    'SAR', // Saudi riyal
    'IQD', // Iraqi dinar
    'LBP', // Lebanese pound
    'SYP', // Syrian pound
    'YER', // Yemeni rial
    'HNL', // Honduran lempira
    'RWF', // Rwandan franc
    'MGA', // Malagasy ariary
    'AFN', // Afghan afghani
    'BIF', // Burundian franc
    'CDF', // Congolese franc
    'GNF', // Guinean franc
    'KIP', // Laotian kip
    'MMK', // Myanmar kyat
    'MNT', // Mongolian tugrik
    'NPR', // Nepalese rupee
    'SBD', // Solomon Islands dollar
    'TOP', // Tongan paʻanga
    'TVD', // Tuvaluan dollar
    'MOP', // Macanese pataca
    'BND', // Brunei dollar
    'PAB', // Panamanian balboa
    'KYD', // Cayman Islands dollar
    'GEL', // Georgian lari
    'KPW', // North Korean won
    'LAK', // Laotian kip
    'MWK', // Malawian kwacha
    'BWP', // Botswanan pula
    'ETB', // Ethiopian birr
    'KGS', // Kyrgyzstani som
    'NAD', // Namibian dollar
    'SLL', // Sierra Leonean leone
    'SZL', // Swazi lilangeni
    'TJS', // Tajikistani somoni
    'TMT', // Turkmenistani manat
    'UZS', // Uzbekistani som
    'XAF', // Central African CFA franc
    'XOF', // West African CFA franc
    'XPF', // CFP franc
    'CUP', // Cuban peso
    'DOP', // Dominican peso
    'KHR', // Cambodian riel
    'MVR', // Maldivian rufiyaa
    'NIO', // Nicaraguan córdoba
    'SHP', // Saint Helena pound
    'TTD', // Trinidad and Tobago dollar
    'XDR', // International Monetary Fund (IMF) Special Drawing Rights
    'STN', // São Tomé and Príncipe dobra
    'SVC', // Salvadoran colón
    'JMD', // Jamaican dollar
    'PYG', // Paraguayan guarani
    'TWD', // New Taiwan dollar
    'BBD', // Barbadian dollar
    'AWG', // Aruban florin
    'FJD', // Fijian dollar
    'GMD', // Gambian dalasi
    'HTG', // Haitian gourde
];

// Default progressBarDetails
export const DEFAULT_PROGRESS_BAR = {
    PROGRESS_BAR_TARGET_VALUE: 200,
    PROGRESS_BAR_CURRENT_VALUE: 0,
    PROGRESS_BAR_DISCOUNT_VALUE: `5`,
    PROGRESS_BAR_TEXT_VALUE: `$0/$200`

}

export const SHIPPING_LIMITS = {
    active: true,
    limit: 1000
};

export const CART_DETAILS = {
    priceSummary: {
        total: {
            amount: 0
        },
    },
    currency: "USD",
};